// ===========================================================================
// Estilos da aba "Inserção manual" v2 (composer seccionado).
//
// Os primitivos genéricos do composer (FormCard, Section*, FormGrid, Field*,
// ControlScope, Collapse*, FormFoot…) foram PROMOVIDOS a
// `styles/ui/Composer.js` em 2026-09-10, quando Transferências passou a
// reusá-los (migrate-on-touch do FC7 cap.2 §H.4 — extrair, não copiar). Este
// arquivo re-exporta de lá para não churnar os consumidores do Routing
// (ManualEntryTab, CustomerLinkedBlock, ConfirmItemModal, NewCustomerModal).
//
// Fica aqui só o que é específico do domínio do Routing (WindowBlock).
// ===========================================================================
import styled from 'styled-components';

export * from '../../../../../styles/ui/Composer';

// ---------------------------------------------------------------------------
// Bloco da janela de horário marcado (realce âmbar sutil — restrição)
// ---------------------------------------------------------------------------
export const WindowBlock = styled.div`
   grid-column: 1 / -1;
   border-radius: 12px;
   padding: 12px 13px;
   border: 1px solid ${({ $invalid, theme }) =>
      ($invalid ? theme?.colors?.danger ?? '#c62828' : '#f0ddcb')};
   background: ${({ $invalid }) =>
      ($invalid ? 'rgba(198,40,40,0.05)' : 'rgba(232,132,60,0.08)')};

   .wl {
      display: flex;
      align-items: center;
      gap: 6px;
      margin-bottom: 8px;
      font-size: 11.5px;
      font-weight: 700;
      color: #a85e29;
   }
   .win-inputs {
      display: flex;
      align-items: center;
      gap: 9px;
   }
   .win-inputs input {
      height: 40px;
      width: 100%;
      padding: 0 11px;
      border-radius: 10px;
      border: 1px solid #e6c7a9;
      background: #fff;
      font-size: 14px;
      font-family: inherit;
   }
   .win-inputs input:focus {
      outline: none;
      border-color: #e8843c;
      box-shadow: 0 0 0 3px rgba(232, 132, 60, 0.18);
   }
   .win-sep {
      flex-shrink: 0;
      font-size: 13px;
      font-weight: 600;
      color: #a85e29;
   }
   .wh {
      margin-top: 7px;
      font-size: 11px;
      color: #a85e29;
      opacity: 0.85;
   }
   .err-msg {
      display: flex;
      align-items: center;
      gap: 5px;
      margin-top: 7px;
      font-size: 11.5px;
      font-weight: 600;
      color: ${({ theme }) => theme?.colors?.danger ?? '#c62828'};
   }
`;

// Botões: origem do padrão visual canônico (44px/radius 11) — promovidos ao
// kit FC7 em styles/ui/Button.js; re-export para não churnar os consumidores.
// SmallButton: a antiga prop $link virou $intent="link" no kit.
export {
   GhostButton,
   PrimaryButton,
   SmallButton,
} from '../../../../../styles/ui/Button';
